import React, { useEffect, useState } from 'react';
import SEO from '../components/SEO';
import FAQ from '../components/FAQ';

const PartnerWithUs = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const [sliderIndex, setSliderIndex] = useState(0);
  const [transitionEnabled, setTransitionEnabled] = useState(true);
  const [slider2Index, setSlider2Index] = useState(0);
  const [transition2Enabled, setTransition2Enabled] = useState(true);
  const [isMobile, setIsMobile] = useState(false);
  const [isHovered1, setIsHovered1] = useState(false);
  const [isHovered2, setIsHovered2] = useState(false);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 768);
    handleResize(); // Initialize
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const pwuCards = [
    {
      title: 'Attractive Revenue Opportunities',
      desc: 'The partnership program is designed to create sustainable income streams for partners. Through transparent revenue-sharing models and scalable business opportunities, partners can grow their financial practice while delivering quality services to investors.',
      icon: <img className="img-fluid" alt="Attractive Revenue Opportunities" src="/images/op-icon1.png" />,
    },
    {
      title: 'Reliable Operational and Client Support',
      desc: 'GFSL ensures smooth onboarding, account management, and client servicing support. Our experienced team assists partners in handling operational processes efficiently, allowing them to focus on client engagement and business growth.',
      icon: <img className="img-fluid" alt="Reliable Operational and Client Support" src="/images/op-icon2.png" />,
    },
    {
      title: 'Long-Term Growth Collaboration',
      desc: 'At GFSL, partnerships are built on trust and mutual growth. We work closely with our partners to expand their business networks, strengthen investor relationships, and build a long-term financial advisory practice backed by a trusted brokerage brand.',
      icon: <img className="img-fluid" alt="Long-Term Growth Collaboration" src="/images/op-icon3.png" />,
    },
    {
      title: 'Established Market Expertise',
      desc: 'With over three decades of experience in the financial markets, GFSL brings deep industry knowledge and proven market understanding. Partners benefit from insights shaped by multiple market cycles, enabling them to guide clients with confidence and credibility.',
      icon: <img className="img-fluid" alt="Established Market Expertise" src="/images/op-icon4.png" />,
    },
    {
      title: 'Comprehensive Investment Solutions',
      desc: 'GFSL provides access to a wide range of financial products including equities, derivatives, mutual funds, and portfolio advisory services. This allows partners to offer diversified investment opportunities and meet the varied financial goals of their clients under one trusted platform.',
      icon: <img className="img-fluid" alt="Comprehensive Investment Solutions" src="/images/op-icon5.png" />,
    },
    {
      title: 'Strong Research and Market Insights',
      desc: 'Our dedicated research support helps partners stay ahead of market trends with timely insights, investment ideas, and sector analysis. This empowers partners to make informed recommendations and strengthen their client relationships through value-added advisory.',
      icon: <img className="img-fluid" alt="Strong Research and Market Insights" src="/images/op-icon6.png" />,
    },
  ];

  const originalLength = pwuCards.length;
  const infiniteCards = [...pwuCards, ...pwuCards];

  useEffect(() => {
    if (sliderIndex >= originalLength) {
      const timeout = setTimeout(() => {
        setTransitionEnabled(false);
        setSliderIndex(sliderIndex - originalLength);
      }, 500);
      return () => clearTimeout(timeout);
    }
  }, [sliderIndex, originalLength]);

  useEffect(() => {
    if (!transitionEnabled) {
      const timeout = setTimeout(() => {
        setTransitionEnabled(true);
      }, 50);
      return () => clearTimeout(timeout);
    }
  }, [transitionEnabled]);

  useEffect(() => {
    if (isHovered1) return;
    const timer = setInterval(() => {
      setSliderIndex((prev) => prev + 1);
    }, 5000);
    return () => clearInterval(timer);
  }, [isHovered1]);

  const handleNext = () => setSliderIndex((prev) => prev + 1);
  const handlePrev = () => {
    if (sliderIndex === 0) {
      setTransitionEnabled(false);
      setSliderIndex(originalLength);
      setTimeout(() => {
        setTransitionEnabled(true);
        setSliderIndex(originalLength - 1);
      }, 50);
    } else {
      setSliderIndex((prev) => prev - 1);
    }
  };

  const pwuPartnerCards = [
    {
      title: 'Sub-Brokers and Authorized Persons',
      desc: 'Existing sub-brokers or market intermediaries who want to associate with a trusted brokerage house can leverage GFSL’s infrastructure, research support, and brand credibility to grow their business.',
      icon: <img className="img-fluid" alt="Sub-Brokers and Authorized Persons" src="/images/op-icon11.png" />,
    },
    {
      title: 'Business Owners and Entrepreneurs',
      desc: 'Individuals with strong local networks and an interest in the financial markets can build a new revenue stream by introducing clients to GFSL’s investment and trading services.',
      icon: <img className="img-fluid" alt="Business Owners and Entrepreneurs" src="/images/op-icon22.png" />,
    },
    {
      title: 'Financial Institutions and Professional Networks',
      desc: 'Organizations such as advisory firms, consultancy groups, or financial service providers can partner with GFSL to enhance their client offerings with reliable broking and advisory solutions.',
      icon: (
        <img className="img-fluid" alt="Financial Institutions and Professional Networks" src="/images/op-icon33.png" />
      ),
    },
    {
      title: 'Independent Financial Advisors (IFAs)',
      desc: 'Professionals who already advise clients on investments, mutual funds, or financial planning can partner with GFSL to expand their offerings into equity trading, portfolio strategies, and broader market opportunities.',
      icon: <img className="img-fluid" alt="Independent Financial Advisors (IFAs)" src="/images/op-icon44.png" />,
    },
    {
      title: 'Wealth Managers and Investment Consultants',
      desc: 'Individuals or firms engaged in wealth advisory can collaborate with GFSL to provide clients with a reliable trading platform, research insights, and diversified investment solutions.',
      icon: <img className="img-fluid" alt="Wealth Managers and Investment Consultants" src="/images/op-icon55.png" />,
    },
    {
      title: 'Chartered Accountants and Tax Consultants',
      desc: 'CAs and tax professionals often work closely with clients on financial matters. Partnering with GFSL enables them to complement their services by offering structured investment opportunities and market access.',
      icon: <img className="img-fluid" alt="Chartered Accountants and Tax Consultants" src="/images/op-icon6.png" />,
    },
  ];

  const originalLength2 = pwuPartnerCards.length;
  const infiniteCards2 = [...pwuPartnerCards, ...pwuPartnerCards];

  useEffect(() => {
    if (slider2Index >= originalLength2) {
      const timeout = setTimeout(() => {
        setTransition2Enabled(false);
        setSlider2Index(slider2Index - originalLength2);
      }, 500);
      return () => clearTimeout(timeout);
    }
  }, [slider2Index, originalLength2]);

  useEffect(() => {
    if (!transition2Enabled) {
      const timeout = setTimeout(() => {
        setTransition2Enabled(true);
      }, 50);
      return () => clearTimeout(timeout);
    }
  }, [transition2Enabled]);

  useEffect(() => {
    if (isHovered2) return;
    const timer = setInterval(() => {
      setSlider2Index((prev) => prev + 1);
    }, 5000);
    return () => clearInterval(timer);
  }, [isHovered2]);

  const handleNext2 = () => setSlider2Index((prev) => prev + 1);
  const handlePrev2 = () => {
    if (slider2Index === 0) {
      setTransition2Enabled(false);
      setSlider2Index(originalLength2);
      setTimeout(() => {
        setTransition2Enabled(true);
        setSlider2Index(originalLength2 - 1);
      }, 50);
    } else {
      setSlider2Index((prev) => prev - 1);
    }
  };

  return (
    <div className="partner-page">
      <SEO
        title="Partner With Us - Gateway Financial Services Ltd."
        description="Join Gateway Financial as a business partner, sub-broker, or financial advisor. Leverage our established market expertise and infrastructure to grow your business."
      />

      {/* BEGIN: Hero Section */}
      <section
        className="pwu-hero-bg text-white position-relative"
        style={{
          backgroundImage:
            "linear-gradient(rgba(12, 59, 68, 0.7), rgba(12, 59, 68, 0.7)), url('/images/banners/partner-with-us-banner.webp')",
        }}
      >
        <div className="container position-relative" style={{ zIndex: 10 }}>
          <div className="row">
            <div className="col-lg-8">
              <h1 className="pwu-hero-title mb-4">Partner With Us</h1>
            </div>
          </div>
        </div>
      </section>
      {/* END: Hero Section */}

      <div style={{ backgroundColor: '#ebf3f5' }}>
        <main>
          {/* BEGIN: Why Partner Section */}
          <section className="py-5 py-lg-5 container">
            <div className="row align-items-center mb-5 pb-4">
              <div className="col-lg-5 mb-4 mb-lg-0 d-flex justify-content-center">
                <div className="pwu-image-wrapper">
                  <img
                    alt="Handshake over desk"
                    className="pwu-curved-image img-fluid"
                    src="/images/banners/why-partner-with-us.webp"
                  />
                </div>
              </div>
              <div className="col-lg-7 pl-lg-5">
                <h2 data-aos="fade-up" className="text-gateway-dark pwu-main-heading mb-4">
                  Why Partner With Us?
                </h2>
                <p className="text-gateway-dark pwu-leading-relaxed mb-4">
                  Partner With Us is a collaborative program designed for professionals, financial advisors, and
                  business associates who want to grow their business by offering trusted financial and investment
                  services to their clients. At GFSL, we believe strong partnerships create stronger financial outcomes.
                  Our partnership model enables individuals and organizations to leverage our decades of market
                  experience, research-driven insights, and reliable infrastructure to deliver value to investors.
                </p>
                <p className="text-gateway-dark pwu-leading-relaxed m-0">
                  By partnering with us, you gain access to a comprehensive ecosystem that includes equity trading,
                  portfolio advisory, research support, and client servicing assistance. We empower our partners with
                  the tools, knowledge, and operational support required to build long-term relationships with investors
                  while expanding their own revenue opportunities. Whether you are an independent advisor, wealth
                  consultant, or business network looking to diversify your offerings, our partnership program helps you
                  scale with confidence while maintaining a client-first approach.
                </p>
              </div>
            </div>
          </section>
          {/* END: Why Partner Section */}

          {/* BEGIN: Why Choose GFSL Section */}
          <div className="bg-white w-100 pwu-why-choose-wrapper">
            <section className="py-5 container">
              <h3 className="text-gateway-dark mb-5" data-aos="fade-up" style={{ maxWidth: '600px' }}>
                Why Choose a Partnership with GFSL?
              </h3>
              <div className="mb-5 mx-n3" style={{ overflow: 'hidden' }}>
                <div
                  className="d-flex"
                  style={{
                    transform: `translateX(-${sliderIndex * (isMobile ? 100 : 50)}%)`,
                    transition: transitionEnabled ? 'transform 0.5s ease-in-out' : 'none',
                    width: '100%',
                  }}
                  onMouseEnter={() => setIsHovered1(true)}
                  onMouseLeave={() => setIsHovered1(false)}
                >
                  {infiniteCards.map((card, idx) => (
                    <div
                      key={idx}
                      className="flex-shrink-0 px-3 py-2"
                      style={{
                        flex: `0 0 ${isMobile ? '100%' : '50%'}`,
                        maxWidth: isMobile ? '100%' : '50%',
                      }}
                    >
                      <div className="serv-box text-left hserv_minhight h-100 px-4 px-md-5">
                        <div className="d-flex align-items-start">
                          <div className="mr-4 flex-shrink-0" style={{ width: '64px', height: '64px' }}>
                            {card.icon}
                          </div>
                          <div>
                            <h4 className="font-weight-bold text-gateway-dark mb-3" style={{ whiteSpace: 'pre-line' }}>{card.title}</h4>
                            <p className="text-gateway-dark pwu-leading-relaxed mb-0">{card.desc}</p>
                          </div>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>

              {/* Slider Controls */}
              <div className="row mt-4">
                <div className="col-12 d-flex justify-content-center justify-content-md-between align-items-center">
                  <button className="pwu-slider-btn" onClick={handlePrev}>
                    <svg style={{ width: '20px', height: '20px' }} fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path d="M15 19l-7-7 7-7" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2"></path>
                    </svg>
                  </button>
                  <div className="d-flex" style={{ gap: '8px' }}>
                    {Array.from({ length: originalLength }).map((_, idx) => (
                      <div
                        key={idx}
                        className={`pwu-dot ${idx === sliderIndex % originalLength ? 'active' : ''}`}
                        onClick={() => {
                          setTransitionEnabled(true);
                          setSliderIndex(idx);
                        }}
                        style={{ cursor: 'pointer' }}
                      ></div>
                    ))}
                  </div>
                  <button className="pwu-slider-btn" onClick={handleNext}>
                    <svg style={{ width: '20px', height: '20px' }} fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path d="M9 5l7 7-7 7" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2"></path>
                    </svg>
                  </button>
                </div>
              </div>
            </section>
          </div>
          {/* END: Why Choose GFSL Section */}

          {/* BEGIN: Who Can Become Partner Section */}
          <div className="bg-white w-100 pwu-who-can-become-wrapper">
            <section className="py-5 container">
              <div className="row justify-content-center">
                <div className="col-lg-8 text-center mb-5">
                  <h3 className="text-gateway-dark mb-4" data-aos="fade-up">
                    Who Can Become Our Partner?
                  </h3>
                  <p className="text-gateway-dark mx-auto" style={{ maxWidth: '600px' }}>
                    Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore
                    et dolore magna aliqua.
                  </p>
                </div>
              </div>
              
              <div className="row position-relative align-items-center">
                <button 
                  className="pwu-slider-btn position-absolute d-none d-md-flex" 
                  style={{ left: '0', zIndex: 10, top: '50%', transform: 'translateY(-50%)' }} 
                  onClick={handlePrev2}
                >
                  <svg style={{ width: '20px', height: '20px' }} fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path d="M15 19l-7-7 7-7" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2"></path>
                  </svg>
                </button>

                <div className="col-12 px-md-5">
                  <div className="mx-n3" style={{ overflow: 'hidden' }}>
                    <div
                      className="d-flex"
                      style={{
                        transform: `translateX(-${slider2Index * (isMobile ? 100 : 50)}%)`,
                        transition: transition2Enabled ? 'transform 0.5s ease-in-out' : 'none',
                        width: '100%',
                      }}
                      onMouseEnter={() => setIsHovered2(true)}
                      onMouseLeave={() => setIsHovered2(false)}
                    >
                      {infiniteCards2.map((card, idx) => (
                        <div
                          key={idx}
                          className="flex-shrink-0 px-3 py-2"
                          style={{
                            flex: `0 0 ${isMobile ? '100%' : '50%'}`,
                            maxWidth: isMobile ? '100%' : '50%',
                          }}
                        >
                          <div className="pwu-bordered-card h-100 text-left" style={{ backgroundColor: '#ebf3f5' }}>
                            <div className="pwu-icon-wrapper mb-4" style={{ backgroundColor: 'transparent', justifyContent: 'flex-start' }}>{card.icon}</div>
                            <h4 className="font-weight-bold text-gateway-dark mb-3" style={{ whiteSpace: 'pre-line' }}>
                              {card.title}
                            </h4>
                            <p className="text-gateway-dark pwu-leading-relaxed mb-0">{card.desc}</p>
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>

                <button 
                  className="pwu-slider-btn position-absolute d-none d-md-flex" 
                  style={{ right: '0', zIndex: 10, top: '50%', transform: 'translateY(-50%)' }} 
                  onClick={handleNext2}
                >
                  <svg style={{ width: '20px', height: '20px' }} fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path d="M9 5l7 7-7 7" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2"></path>
                  </svg>
                </button>

                {/* Mobile arrows (optional, since dots are removed, we should probably just show them on mobile too) */}
                <div className="col-12 d-flex justify-content-between d-md-none mt-4">
                  <button className="pwu-slider-btn" onClick={handlePrev2}>
                    <svg style={{ width: '20px', height: '20px' }} fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path d="M15 19l-7-7 7-7" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2"></path>
                    </svg>
                  </button>
                  <button className="pwu-slider-btn" onClick={handleNext2}>
                    <svg style={{ width: '20px', height: '20px' }} fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path d="M9 5l7 7-7 7" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2"></path>
                    </svg>
                  </button>
                </div>
              </div>
            </section>
          </div>
          {/* END: Who Can Become Partner Section */}



          <FAQ />
        </main>
      </div>

      {/* BEGIN: App Download Section */}
      <section id="app-section">
        <div className="container">
          <div className="row">
            <div className="col-lg-6 align-self-center">
              <h3 data-aos="fade">Download our Investment Fund App</h3>
              <p>Investing With Gateway Financial Services Limited</p>
              <a href="#download" className="lm-btn">
                Download &amp; Explore More
              </a>
            </div>
            <div className="col-lg-6">
              <img
                src="/images/download.avif"
                className="img-fluid"
                alt="Download App Preview"
              />
            </div>
          </div>
        </div>
      </section>
      {/* END: App Download Section */}
    </div>
  );
};

export default PartnerWithUs;
